(function () {
  'use strict';

  var root = document.querySelector('[data-fn-search]');
  if (!root || root.dataset.fnSearchReady === 'true') return;

  var form = root.querySelector('[data-fn-search-form]');
  var input = root.querySelector('[data-fn-search-input]');
  var clearButton = root.querySelector('[data-fn-search-clear]');
  var submitButton = root.querySelector('[data-fn-search-submit]');
  var status = root.querySelector('[data-fn-search-status]');
  function getIntelligence() { return window.FoodNetSearchIntelligence; }
  var recoveryKey = 'foodnet-search-recovery-v2';
  var resolutionKey = 'foodnet-search-resolution-v2';
  var activeController = null;

  if (!form || !input || !clearButton || !submitButton || !status) return;

  root.dataset.fnSearchReady = 'true';

  function normalize(value) {
    var intelligence = getIntelligence();
    if (intelligence && typeof intelligence.normalize === 'function') {
      return intelligence.normalize(value);
    }
    return String(value || '').trim().toLowerCase();
  }

  function setClearVisibility() {
    clearButton.hidden = input.value.length === 0;
  }

  function clearValidationMessage() {
    input.removeAttribute('aria-invalid');
    status.textContent = '';
    status.hidden = true;
  }

  function showStatus(message) {
    status.textContent = message;
    status.hidden = false;
  }

  function setSubmitState(busy) {
    if (busy) {
      form.setAttribute('aria-busy', 'true');
      submitButton.disabled = true;
      submitButton.querySelector('span').textContent = 'Slim zoeken…';
    } else {
      form.removeAttribute('aria-busy');
      submitButton.disabled = false;
      submitButton.querySelector('span').textContent = 'Zoeken';
    }
  }

  function buildSearchUrl(term) {
    var url = new URL(form.action || window.location.pathname, window.location.origin);
    new FormData(form).forEach(function (value, key) {
      url.searchParams.set(key, String(value));
    });
    url.searchParams.set('q', term);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url.toString();
  }

  function rememberResolution(raw, best) {
    if (normalize(raw) === normalize(best)) return;
    try {
      sessionStorage.setItem(resolutionKey, JSON.stringify({ raw: raw, best: best, at: Date.now() }));
    } catch (_) {}
  }

  function showResolvedNotice() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(resolutionKey) || 'null');
      if (!saved || !saved.raw || !saved.best || Date.now() - Number(saved.at || 0) > 120000) return;
      if (normalize(input.value) !== normalize(saved.best)) return;
      sessionStorage.removeItem(resolutionKey);
      showStatus('We hebben “' + saved.raw + '” geïnterpreteerd als “' + saved.best + '”.');
    } catch (_) {}
  }

  function canUseIntelligence(query) {
    var intelligence = getIntelligence();
    if (!intelligence || typeof intelligence.resolve !== 'function' || typeof intelligence.findBestTerm !== 'function') return false;
    if (typeof intelligence.isSkuLike === 'function' && intelligence.isSkuLike(query)) return false;
    var resolution = intelligence.resolve(query);
    return !!(resolution && resolution.reason && Array.isArray(resolution.candidates) && resolution.candidates.length > 1);
  }

  async function resolveAndNavigate(query, replace) {
    activeController?.abort();
    activeController = new AbortController();
    setSubmitState(true);
    showStatus('We controleren ook spelling en andere talen…');

    try {
      var intelligence = getIntelligence();
      if (!intelligence) throw new Error('Search intelligence unavailable');
      var best = await intelligence.findBestTerm(query, activeController.signal);
      best = best || query;
      if (replace && normalize(best) === normalize(query)) {
        setSubmitState(false);
        status.textContent = '';
        status.hidden = true;
        return;
      }
      rememberResolution(query, best);
      var url = buildSearchUrl(best);
      if (replace) window.location.replace(url);
      else window.location.assign(url);
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      var fallbackUrl = buildSearchUrl(query);
      if (replace) window.location.replace(fallbackUrl);
      else window.location.assign(fallbackUrl);
    }
  }

  async function recoverZeroResults() {
    var queryFromUrl = new URLSearchParams(window.location.search).get('q');
    if (!queryFromUrl || !root.querySelector('.fn-search__empty')) return;

    var query = input.value.trim();
    if (query.length < 2 || !canUseIntelligence(query)) return;

    var guard = normalize(query);
    try {
      if (sessionStorage.getItem(recoveryKey) === guard) return;
      sessionStorage.setItem(recoveryKey, guard);
    } catch (_) {}

    await resolveAndNavigate(query, true);
  }

  input.addEventListener('input', function () {
    setClearVisibility();
    if (input.getAttribute('aria-invalid') === 'true') {
      clearValidationMessage();
    } else if (!status.hidden) {
      status.textContent = '';
      status.hidden = true;
    }
  });

  clearButton.addEventListener('click', function () {
    activeController?.abort();
    input.value = '';
    setClearVisibility();
    clearValidationMessage();
    setSubmitState(false);
    input.focus();
  });

  form.addEventListener('submit', function (event) {
    var query = input.value.trim();

    if (!query) {
      event.preventDefault();
      input.value = '';
      input.setAttribute('aria-invalid', 'true');
      showStatus('Vul een product, merk of SKU in.');
      setClearVisibility();
      input.focus();
      return;
    }

    input.value = query;
    input.removeAttribute('aria-invalid');

    if (!canUseIntelligence(query)) {
      setSubmitState(true);
      return;
    }

    event.preventDefault();
    resolveAndNavigate(query, false);
  });

  window.addEventListener('pageshow', function () {
    setSubmitState(false);
    setClearVisibility();
  });

  setClearVisibility();
  showResolvedNotice();
  if (getIntelligence()) recoverZeroResults();
  else document.addEventListener('foodnet:search-intelligence-ready', recoverZeroResults, { once: true });
})();
